const faqs = [
  { q: 'Pulsuz plandan Pro-ya necə keçə bilərəm?', a: 'Hesab ayarlarınızdan "Plan Dəyişdir" seçimini klikləyin. Keçid anındadır, məlumatlarınız qorunur.' },
  { q: 'Kredit kartı olmadan başlaya bilərəmmi?', a: 'Bəli! Pulsuz planımız üçün heç bir ödəniş məlumatı lazım deyil.' },
  { q: 'İllik planı aylıq ödəyə bilərəmmi?', a: 'İllik plan tam olaraq ilin əvvəlində ödənilir. Aylıq plan seçsəniz hər ay ödəniş edirsiniz.' },
  { q: 'Xüsusi domenimi necə əlavə edim?', a: 'Pro və Biznes planlarında Hesab > Domenlər bölmərindən DNS ayarlarınızı daxil edin.' },
  { q: 'Məlumatlarım təhlükəsizdirmi?', a: 'AES-256 şifrələmə, GDPR uyğunluğu və yerli serverlər sayəsində məlumatlarınız tam qorunur.' },
];

export default function PricingFAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div className="max-w-3xl mx-auto mt-24">
      <h2 className="font-display text-3xl font-bold text-slate-900 text-center mb-10">Tez-tez Verilən Suallar</h2>
      <div className="space-y-3">
        {faqs.map((faq, i) => (
          <div key={i} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between px-6 py-4 text-left">
              <span className="font-medium text-slate-900 text-sm">{faq.q}</span>
              <svg className={`w-4 h-4 text-slate-400 transition-transform flex-shrink-0 ml-4 ${open === i ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            </button>
            {open === i && <div className="px-6 pb-4 text-slate-500 text-sm leading-relaxed">{faq.a}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
